// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3CjIX","title":"Info_title__2tsjF","selects":"Info_selects__3aTB3","requiredAsterisk":"Info_requiredAsterisk__W9GZ2"};